import { setAuth0TokenGetter } from "@/shared/lib/auth0-token";
import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";

interface Auth0TokenProviderProps {
  children: React.ReactNode;
}

export function Auth0TokenProvider({ children }: Auth0TokenProviderProps) {
  const { getAccessTokenSilently, isAuthenticated, isLoading } = useAuth0();

  useEffect(() => {
    const getToken = async (): Promise<string | null> => {
      if (isLoading) {
        return null;
      }

      if (!isAuthenticated) {
        return null;
      }

      try {
        const audience =
          import.meta.env.VITE_AUTH0_AUDIENCE;
        const token = await getAccessTokenSilently({
          authorizationParams: {
            audience: audience,
          },
        });
        return token;
      } catch (error) {
        if (import.meta.env.DEV) {
          console.error("[Auth0TokenProvider] Failed to get access token:", error);
        }
        return null;
      }
    };

    setAuth0TokenGetter(getToken);
  }, [getAccessTokenSilently, isAuthenticated, isLoading]);

  return <>{children}</>;
}
